import React from "react";
import "../css/returns.scss";

function Returns() {
  return (
    <main className="returns policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">Returns</h1>
        <div className="policy-content">
          <div className="policy-callout"><strong>No orders are accepted through this preview site.</strong> There are currently no website purchases to return.</div>
          <h2>When ordering opens</h2>
          <p>A full returns policy will be shown before checkout, including the return window, eligible item condition, exclusions, return method, costs, refund timing and return address. Any mandatory consumer rights that apply to you will remain unaffected.</p>
          <h2>Existing enquiries</h2>
          <p>If you arranged a purchase separately and need help, email <a href="mailto:track@uightparcel.shop?subject=Return%20enquiry">track@uightparcel.shop</a> with your reference and the item details. Do not send card information by email.</p>
          <h2>Rights reserved</h2>
          <p>This page is informational and does not reduce rights provided by applicable consumer law or any more favourable written terms supplied with a purchase.</p>
        </div>
      </div>
    </main>
  );
}

export default Returns;
